module.exports = __webpack_public_path__ + "img/protected-logo.0b7838b8.svg";